import { type IconProps } from '../iconProps';

export const Xmark: React.FC<IconProps> = ({ size, fill }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 18 18'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.9998 11.1217L2.59414 17.5277C2.31236 17.8092 1.95869 17.95 1.53314 17.95C1.10758 17.95 0.753916 17.8092 0.472138 17.5277C0.190582 17.2459 0.0498047 16.8922 0.0498047 16.4667C0.0498047 16.0411 0.190582 15.6874 0.472138 15.4057L6.87814 8.99999L0.472138 2.59432C0.190582 2.31254 0.0498047 1.95888 0.0498047 1.53332C0.0498047 1.10777 0.190582 0.754098 0.472138 0.472321C0.753916 0.190765 1.10758 0.0499878 1.53314 0.0499878C1.95869 0.0499878 2.31236 0.190765 2.59414 0.472321L8.9998 6.87832L15.4055 0.472321C15.6872 0.190765 16.0409 0.0499878 16.4665 0.0499878C16.892 0.0499878 17.2457 0.190765 17.5275 0.472321C17.809 0.754098 17.9498 1.10777 17.9498 1.53332C17.9498 1.95888 17.809 2.31254 17.5275 2.59432L11.1215 8.99999L17.5275 15.4057C17.809 15.6874 17.9498 16.0411 17.9498 16.4667C17.9498 16.8922 17.809 17.2459 17.5275 17.5277C17.2457 17.8092 16.892 17.95 16.4665 17.95C16.0409 17.95 15.6872 17.8092 15.4055 17.5277L8.9998 11.1217Z'
        fill='#E3E3E3'
      />
    </svg>
  );
};
